'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    contentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      marginBottom: theme.modal.spacingVertical,
      '&.disabled': {
        opacity: theme.disabledOpacity
      },
      '&.hidden': {
        display: 'none'
      }
    },
    wrap: {
      flex: '1 1 auto',
      overflowY: 'auto',
      minHeight: 0
    }
  };
};